export default "__VITE_ASSET__CBcheYEr__"